import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SelectEvent, TabPosition, TabStripComponent } from '@progress/kendo-angular-layout';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { RelationAccount } from '~/models/administration/account';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { AssetTypeDto } from '~/models/modules/Asset/assetType';
import { CustomFieldSummary } from '~/models/modules/customField';
import { FormTabSummary } from '~/models/modules/formTab';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { AccountsService } from '~/services/administration.ts/accounts';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { GDataService } from '~/services/GDataService';
import { AssetTypeService } from '~/services/modules/assets/assetType';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { NoteComponent } from '~/shared/components/note/note.component';
import { PageState } from '~/shared/enums/stock-files.enum';

@Component({
    selector: 'department-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class AssetTypeUpsertComponent extends MultiSiteAwareComponent implements OnInit, OnDestroy {

  _title: string = 'Model Type';
  _entity: string = "Asset"
  _page: string = 'asset-types';
  _permissionScope: string = 'asset-types';
  _language = 'en';
  _model: AssetTypeDto;
  _gridColumns: GridFieldSummary[];
  _theme: string;
  _currentUser: UserSummary;
  _listItems: Array<string> = [];
  _isActiveGrid: boolean = true;
  _inActiveMode: boolean = false;
  _isDialiog: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;
  deactivateItem: any;
  deactivate: boolean = false;
  _gridFieldText: GridFieldTextSummary[];
  _gridFieldAuth: GridFieldAuthorization[];
  selectedobjectname: string = null;
  _invalidForm: boolean = false;
  _invalidSubmit: boolean;
  _isOs: boolean;

  _pageState: PageState;
  _active: boolean;
  copyModelId: number;
  _form: FormGroup;
  _modelTypeId = new FormControl();
  _modelTypeDescription = new FormControl();


  // #region Custom Fields / Edit Form
  _customForm: any;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _selectedLabelObjectCode: string;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isMandatory: boolean = false;
  _custominvalidForm: boolean = false;
  reactivate: boolean = false;
  reactivateItem: any;
  requiredSystemTabs: any = [];
  _requiredFieldNames: any = [];
  _requiredFields: any = [];
  _additionalErrors: any = [];

  _customFields: CustomFieldSummary[][] = [];
  _customFieldsDictionary: { [key: string]: string } = {};
  _customFieldsValue: any[];
  _customValidation: any = [];
  _systemFields: GridFieldSummary[] = [];
  _editedSystemFields: any = [];
  // #endregion

  // #region Tab Containers
  _kendoTabStripPosition: TabPosition = 'left';
  _dataTabs: Array<FormTabSummary> = [];
  _dataTabsSelected: Array<FormTabSummary> = [];
  _userNewDataTabs: Array<FormTabSummary> = [];
  _customTabs: any;
  _tabDisabledIndexes: number[] = [];
  // #endregion

  // #region Popup Statuses
  _editFormActive: boolean;
  _orderingTabsForm: boolean = false;
  _deactivatedFieldsForm: boolean = false;
  _isEditForms: boolean = false;
  _selectedTabId: number;
  _selectedLabelId: number;
  _deactivatedFieldsGridData: any[] = [];
  // #endregion
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('kendo_tabstrip_wrapper') screenTabs: ElementRef;
  @ViewChild('kendo_tabstrip') public screenTabStrip: TabStripComponent;
  @ViewChild('kendo_BarcodeGen_Model_TypeId') kendoInpuModelTypeId: ElementRef;
  @ViewChild('kendo_ModelTypeDescription') kendoInputModelTypeDescription: ElementRef;
  @ViewChild('note') note: NoteComponent;
  // #region Enterprise Data
  _addClassActive: boolean = false;
  _selectedAccounts: any[] = [];
  declare _tabEnabled: boolean;

  // #endregion

  constructor(
    private _accountsService: AccountsService,
    private _fb: FormBuilder,
    private _assetTypeService: AssetTypeService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _sharedService: SharedService,
    private _securityService: SecurityService,
    private _themeManager: ThemeManagerService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _layoutManager: LayoutManagerService,
    private _dataService: GDataService,
    private _layoutComponent: LayoutComponent) {
    super();
  }

  ngOnDestroy(): void {
  }
  async ngOnInit() {
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    if (window.navigator.userAgent.indexOf('Mac') != -1) {
      this._isOs = true;
    };
    this._layoutManager.applyOverly();
    this._currentUser = this._securityService.currentUser;
    this.getAuth();
    this._getdata();

    this.loadLabels();

    this._getAccountIds();
    this.getSystemFieldsAndCustomFields();
    this._getInactiveFields();
    this._initForm();
    this.getFormTabs();
    if (!this._currentUser.isEnterprise) {
      this._tabEnabled = true;
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.screenTabStrip != undefined) {
        this.screenTabStrip.selectTab(0);
      }
    }, 300);

  }
  _getAccounts = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  };
  _getdata(): void {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;
    if (this._pageState == PageState.COPY) {
      this.copyModelId = this._model.id; // for loading custom fields data if there is any
    }
    if ((this._pageState === PageState.ADD || this._pageState == PageState.COPY) && this._model && this._model.id > 0) {
      this._model.id = 0;
    }
    if (this._pageState == PageState.ADD) {
      this._model.id = 0;
    }
    if (this._pageState == PageState.COPY)
      this._pageState = PageState.ADD;
    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
      this._selectedAccounts = (this._model?.assetTypeAccounts ?? []).map(
        (x: any) => +(x.account?.id ?? x.accountId ?? x.id ?? x)
      );
      this._selectedAccountIds = [...this._selectedAccounts];
    }
    this._tabEnabled = this._selectedAccounts.length > 0;
  }
  _initForm() {
    this._form = this._fb.group({
      modelType: [this._model?.modelType, Validators.required],
      description: [this._model?.description, this.getLabel('LBL_AssetTypeDescription')?.isRequired ? Validators.required : null],
    });
  }
  async loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        //this._initForm();
      });
  }
  _getAccountIds() {
    super._getAccountIds();
  }


  // #region Page Controls Actions
  _generateBarCode(): void {
    this._barcodeGeneratorsService.getBarcode(this._page, 1)

      .subscribe((data: any) => {
        this._modelTypeId.setValue(data.result.toString());
        this._form.patchValue({
          modelType: data.result.toString(),
        });
        if (this._pageState == PageState.ADD) {
          setTimeout(() => {
            if (this.kendoInputModelTypeDescription != undefined) {
              this.kendoInputModelTypeDescription.nativeElement.focus();
            }
          });
        }
      });
  }
  _NumberSubmitted(): void {
    if (this._form.controls.modelType.value != undefined && this._form.controls.modelType.value.trim() != '') {
      setTimeout(() => {
        if (this.kendoInputModelTypeDescription != undefined) {
          this.kendoInputModelTypeDescription.nativeElement.focus();
        }
      });
    }
  }
  getLabel(objectCode: string): GridFieldTextSummary {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;
      return result ? result : null;
    }
  }
  //#endregion

  // #region Popup Action Buttons
  _onSave(e: string): any {
    var sitesSelected: boolean = true;
    if (this._currentUser.isEnterprise) {
      if (this._currentUser.isEnterprise && this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select account(s) to continue.',
        });
        return false;
      }
      else {
        var tmpAccountSites = this._selectedAccounts.filter(
          (x: any) => x.siteId != -1
        );
        if (tmpAccountSites.length != this._selectedAccounts.length) {
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Please select the site(s) of the selected account(s) to continue.',
          });
          sitesSelected = false;
          return false;
        }
      }
    }
    this._invalidForm = false;
    if (!this._invalidForm) {
      if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
        this._invalidForm = true;
        this._invalidSubmit = true;
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }
      else if (this._form.invalid) {
        this._invalidForm = true;
      }
      else if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
        this._invalidSubmit = true;
        this._invalidForm = true;
      }
      else {
        // work with custom fields
        if (this._customFieldsValue) {
          this._customFieldsValue.forEach((elementy: any) => {
            this._customFieldsDictionary[elementy.Key] = elementy.Value;
          });
        }
        this._invalidForm = false;
        this._invalidSubmit = false;
        const model: AssetTypeDto = <AssetTypeDto>({
          id: this._model?.id ?? 0,
          modelType: this._form.controls.modelType.value,
          description: this._form.controls.description.value,
          customFieldsValue: this._customFieldsDictionary,
          accountIds: this._selectedAccounts.map((c: any) => (c?.accountId != null ? +c.accountId : +c))
        });
        if ((this._pageState == PageState.ADD || this._pageState == PageState.COPY) && (this._model.id == null || this._model.id == 0)) {
          this._assetTypeService
            .createAssetType(model)

            .subscribe((response: any) => {
              if (response != null && response['message'] != null) {
                if (!this._currentUser.isEnterprise) {
                  this.note.createNote(response.data.data.id);
                }
                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: response['message'],
                  withoutConfirm: true
                });
                if (response['close'] != null) {
                  if (response['close'] == true) {
                    if (e === 'saveAndClose') {
                      this._closeForm(model);
                    }
                    else if (e === 'saveAndCopy') {
                      this._form.controls.modelType.setValue(null);
                      this.copyModelId = this._model.id;
                      this.loadCustomFields(this.copyModelId.toString());
                      this._model.id = 0;
                      this._pageState = PageState.ADD;
                    }
                    else if (e === 'save') {
                      this._pageState = PageState.EDIT;
                      this._model.id = response.data.data.id;
                      this._model = { ...response.data.data };
                    }
                    else if (e === 'saveAndNew') {
                      this._active = false;
                      this._isDialiog = false;
                      this.openUpsert(this._page, {}, PageState.ADD);
                    }
                  }
                  else {
                    return;
                  }
                }
              }
            });
        }
        else if (this._pageState == PageState.EDIT) {
          if (this._model.id == null) {
            this._model.id = model.id;
          }
          this._assetTypeService
            .updateAssetType(this._model.id, model)

            .subscribe((response: any) => {
              if (response != null && response['message'] != null) {
                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: response['message'],
                  withoutConfirm: true
                });
                if (response['close'] != null) {
                  if (response['close'] == true) {
                    if (e === 'saveAndClose') {
                      this._closeForm(model);
                    }
                    else if (e === 'saveAndCopy') {
                      this._form.controls.modelType.setValue(null);
                      this.copyModelId = this._model.id;
                      this.loadCustomFields(this.copyModelId.toString());
                      this._model.id = 0;
                      this._pageState = PageState.ADD;
                    }
                    else if (e === 'save') {
                      this._pageState = PageState.EDIT;
                      this._model.id = response.data.data.id;
                      this._model = { ...response.data.data };
                    }
                    else if (e === 'saveAndNew') {
                      this._active = false;
                      this._isDialiog = false;
                      this.openUpsert(this._page, {}, PageState.ADD);
                    }
                  }
                  else {
                    return;
                  }
                }
              }
            });
        }
      }
    }
  }
  _edit(): void {
    this._pageState = PageState.EDIT;
  }
  _openForm(componentName: string, objectname: any = null) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model: {}, pageState: PageState.ADD, reload: 'model' };
    this._isMandatory = false;
    this.selectedobjectname = objectname;
  }
  _closeDialog(fileData: any) {
    this._isDialiog = false;
  }
  //#endregion

  // #region Popup window Events
  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._active = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState }
  }
  _onCancel() {
    if (this._model?.id) {
      this._closeForm(this._model);
    }
    else {
      this._closeForm();
    }
  }
  _closeForm(model?: any) {
    var closeComponent = {
      component: this._page,
      isClosed: true,
      response: model
    }
    this._isDialiog = false;
    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects(this._page);
    //this.ngOnDestroy();
    this._layoutManager.removeOverlay();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
    //Quraim
    if (model) {
      closeComponent.response = model;
      this._dataService.push(closeComponent);
      this._sharedService.model = {};
    }
  }
  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove("fullWidthFormForm");
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove("fullWidthFormForm");
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add("fullWidthFormForm");
    }
  }

  // #endregion

  // #region Custom Fields / Forms Actions
  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }
  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    } else {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the desired account in the Accounts Tab',
          withoutConfirm: true
        });
      } else {
        this._pageState = PageState.EDIT_FIELDS;
        // this._editFormActive = true;
        // this._isCustomfieldsFormValue = true;
      }
    }
  }
  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _addNewField(tabId: number) {
    this._selectedTabId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set
    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _onEditForms() {
    this._isEditForms = true;
  }
  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
  }
  _viewInactiveFields() {
    this._getInactiveFields();
    /* this._customFieldsService
      .getDeactivatedCustomFields(this._entity, this._page)
      
      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      }); */
    this._deactivatedFieldsForm = true;
  }
  _reactivateField(item: any) {
    this.reactivateItem = item;
    this.reactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            this.getSystemFieldsAndCustomFields();
            this._deactivatedFieldsForm = false;
            //get tabid,if not in list call get systemtabs
            var deletedTab = this._dataTabs.find(f => f.id == item.formTabId && f.isCustom == true);
            if (deletedTab == undefined) {
              this.getFormTabs();
            }
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              /* if (response['close'] != null) {
                if (response['close'] == true) {
                  //this.loadCustomFields(this._model?.id?.toString());
                } else {
                  return;
                }
              } */
            }
            this._deactivatedFieldsForm = false;
          });
        this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name,
    });
    //this.loadCustomFields(this._model?.id?.toString());
    /* this.getSystemFieldsAndCustomFields();
    this._customFieldsService
    .getDeactivatedCustomFields(this._entity,this._page)
    
    .subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    }); */
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }
  dataMove(newLocData: any, oldLocData: any, dataTab?: FormTabSummary) {
    const sysF: GridFieldSummary[] = this._systemFields.filter(f => f.formTabId == dataTab.id);
    const sysFClone: any[] = [];

    sysF.forEach((element: any) => {
      sysFClone.push(Object.assign({}, element));
    });
    sysF.find((x: { id: any; }) => x.id === oldLocData.id).formOrder =
      sysFClone.find((x) => x.id === newLocData.id).formOrder;
    sysF.find((x: { id: any; }) => x.id === newLocData.id).formOrder =
      sysFClone.find((x) => x.id === oldLocData.id).formOrder;

    this._editedSystemFields = sysF;
  }
  dragEnd() {
    this._gridFields
      .updatedSystemFieldReorder(this._editedSystemFields)

      .subscribe((x: GridFieldSummary[]) => {
        this._systemFields = x;
        this._editedSystemFields = x;
      });
  }
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    if (this._customFieldsValue == undefined) { this._customFieldsValue = []; }
    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }
      this._customFieldsValue.push(customObject);
    });

  }
  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (
          this._customFields[i].findIndex((x) => x.id == customFieldId) != -1
        ) {
          this._customFields[i] = this._customFields[i].filter(
            (x) => x.id != customFieldId
          );
          return;
        }
      }
    }
  }
  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
    this.setMandatoryFields();
  }
  _getInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields(this._entity, this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
      });
  }
  // #endregion

  // #region Fields Tab Containers
  getCustomForm(event: any) {
    this._customForm = event;
  }
  _onTabSelect(e: SelectEvent): void {
    this._mobileMenuToggle();
  }
  _mobileMenuToggle() {
    let mobiletabstrip = this.screenTabs.nativeElement.querySelector('ul');
    if (mobiletabstrip.classList != undefined) {
      mobiletabstrip.classList.toggle('visibletab');
    }
  }
  getFormTabs() {
    try {
      this._gridFields
        .getformTabsByPage(this._page)

        .subscribe((x: FormTabSummary[]) => {
          this._dataTabs = x;
          this._dataTabsSelected = x;
          this._userNewDataTabs = x;
          //this.sortProduct(p => p.order, "ASC");
          if (x.length > 1) {
            //this.screenTabStrip.tabs.first.selected = true;
          }
        });
    } catch { }
  }
  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: GridFieldSummary[]) => {
        this._systemFields = [...x];
        this._editedSystemFields = [...x];
        /* this._systemFields.forEach((s:GridFieldSummary, indx: number) =>{
          this._tabDisabledIndexes.push(indx);
        }) */
        this.loadCustomFields(this.copyModelId?.toString() ?? this._model?.id?.toString());
      })
  }
  private loadCustomFields(entityId?: string) {
    entityId = this.copyModelId?.toString() ?? this._model?.id?.toString();
    this._customFieldsService
      .getCustomFields(this._entity, this._page, entityId)

      .subscribe((data) => {
        data.forEach((fieldData: CustomFieldSummary) => {
          if (fieldData.customFieldType.type.toLowerCase() == 'date') {
            if (fieldData.customFieldsData) {
              let _cutomfieldData = fieldData.customFieldsData.find(f => f.entityId == entityId);
              if (_cutomfieldData && _cutomfieldData.value) {
                _cutomfieldData.value = new Date(_cutomfieldData.value).toUTCString();
              }
            }
          }
        });
        data = data.filter(x => x.formTab?.page == this._page);
        if (this._model != null && (this._model.id != null || this.copyModelId != null)) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id ?? that.copyModelId;
          });
        }
        var tabIds = data
          .map((item) => item.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(
          data,
          (item: { formTabId: any }) => item.formTabId
        );
        let that = this;
        tabIds.forEach(function (formTabId) {
          that._customFields[formTabId] = grouped.get(formTabId);
        });
        if (this.copyModelId) {
          let CustomFieldsDataForCopy: any = {};
          grouped.forEach(element => {
            element.forEach((value: any) => {
              let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
              CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;
              if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
              if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            });
            this._customFieldsValueChanges(CustomFieldsDataForCopy, null);

          });
        }
        this.setMandatoryFields();
      });
    //this._pacer.start()
    this._customFieldsService
      .getFormTabsByPage(this._page)

      .subscribe((data: any) => {
        //get custom tabs first
        this._customTabs = data.filter(
          (x: { isCustom: boolean }) => x.isCustom == true
        );
      });
  }
  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }
  setMandatoryFields() {
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    this._customValidation = [];
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }
      this._requiredFields.forEach((element: { isCustomField: any; formTab: any; formTabId: any; }) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });
      if (this.screenTabs) {
        let tabElementList = this.screenTabs.nativeElement.querySelector('ul');
        if (tabElementList) {
          Array.from(tabElementList?.children).forEach((child: any) => {
            child.classList.remove('mendatoryTab');
          });
          Array.from(tabElementList?.children).forEach((child: any) => {
            if (this._requiredFieldNames.find((x: { name: any; page: string; formtab: { page: string; }; }) => x.name === child.firstChild.innerText && (x.page ? x.page == this._page : x.formtab.page == this._page))) {
              child.classList.add("mendatoryTab")
            }
            if (
              this.requiredSystemTabs.find(
                (x: any) =>
                  x.name === child.firstChild.innerText
              )
            ) {
              child.classList.add('mendatoryTab');
            }
          });
        }
      }
      this._requiredFields.forEach((element: { isCustomField: any; formTab: { name: any; }; customFieldsData: any[]; name: any; }) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        if (element.customFieldsData != undefined) {
          let thisvalue =
            element.customFieldsData.filter(
              (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
            ).length > 0
              ? element.customFieldsData.filter(
                (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
              )[0].value
              : '';

          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });


        }
      });


    }, 500);

  }
  _deactivateTab(tabId: number, page: string) {
    let model: any = {
      customFieldEntityId: page == this._page ? 1 : 2,
      page: this._page,
      accountIds: this._selectedAccountIds,
    };
    this._customFieldsService
      .deleteCustomTab(tabId, model)

      .subscribe((response: any) => {
        if (response != null && response['message'] != null) {
          var deletedTab = this._dataTabs.find(f => f.id == tabId && f.isCustom == true);
          this._dataTabs.splice(this._dataTabs.indexOf(deletedTab), 1);
          //go to zero based tab
          this.screenTabStrip.selectTab(0);
          this._customFieldsService
            .getFormTabsByPage(this._page)

            .subscribe((data: any) => {
              //get custom tabs first
              this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
            });
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {

            } else {
              return;
            }
          }
        }

      });

  }
  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }
  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find((x) => x.order == i + 1)) {
      this._userNewDataTabs.find(
        (x) => x === this._dataTabsSelected.find((x) => x.order == i + 1)
      ).order = this._dataTabsSelected.find((x) => x.name === e.name).order;
    }
    this._userNewDataTabs.find((obj) => obj.name == e.name).order = i + 1;
    //this._dataTabsSelected = this._dataTabsSelected.filter((obj) => obj !== e);
  }
  _onSaveTabOrdering() {
    this._gridFields
      .updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._closeOrderingTabsForm();
      });
  }
  // #endregion

  // #region Security Levels
  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }
  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._permissionScope, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }
  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null

      return result ? result : new GridFieldAuthorization();
    }
  }
  // #endregion



  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e);
  }
}
